/**
 * @returns {string[]}
 */
export function readErrors(error) {
    if (!error.response) {
        console.error(error);
    }

    const data = error.response?.data;
    return wrapArray(data?.error ?? data?.errors ?? "An unknown error occurred. Please try again later.");
}

/**
 * @template T
 * @param {T} value
 * @returns {T extends Array ? T : T[]}
 */
export function wrapArray(value) {
    if (value == null) {
        return [];
    }

    return Array.isArray(value) ? value : [value];
}

export function resolvePath(obj, path) {
    return path.split('.').reduce((prev, curr) => prev ? prev[curr] : undefined, obj);
}

export function formatPhoneNumber(phoneNumber) {
    phoneNumber = phoneNumber.match(/\d/g).join("");
    return `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6, 10)}`;
}

export function yearsSinceDate(date) {
    return new Date().getFullYear() - new Date(date).getFullYear();
}

export function localeFormatDate(date) {
    return new Date(date?.replace(/T.+/, "") + "T00:00").toLocaleDateString();
}

/**
 * @param {{firstName: String, middleName?: String, lastName: String}} obj
 * @returns {string}
 */
export function getFullName(obj) {
    if (!obj) {
        return "";
    }

    return obj.middleName ? `${obj.firstName} ${obj.middleName} ${obj.lastName}` : `${obj.firstName} ${obj.lastName}`;
}

let sessionData = {};

export function setSessionData(key, value) {
    sessionData[key] = value;
}

export function getSessionData(key) {
    return sessionData[key];
}

export function clearSessionData() {
    sessionData = {};
}

export function getFileExtension(filename) {
    if (!filename?.includes('.')) {
        return "";
    }

    return filename.split('.').pop();
}